module.exports = __webpack_public_path__ + "fonts/NormaticaDisplay-Demo.f0dc978b.ttf";